import { Grade } from "~/types";
import { getType, itemName, ItemProps } from "~/util/item";
import { useRealm, useT } from "~/util/Lang";
import { Icon32 } from "../ui/Icon";
import { ItemGrade } from "./Grade";
import css from "./ItemInfoBox.module.css";
import { ReactNode } from "react";
import { AdenaValue } from "./Adena";

export function ItemInfoBox(props: ItemProps) {
  const item = props.item;
  const realm = useRealm();
  const t = useT();
  return (
    <div className={css.root}>
      <div className={css.itemHeading}>
        {props.item.icon && (
          <Icon32
            icon={props.item.icon}
            alt={t(props.item.name)}
            game={props.gver}
          />
        )}
        <div>
          <div className={css.itemName}>
            {itemName({
              name: t(props.item.name),
              addName: t(props.item.addName),
            })}
            <ItemGrade grade={props.item.crystalType as Grade} />
          </div>
          <div className={css.itemType}>{getType({ item, realm })}</div>
        </div>
      </div>

      {stat(t({ en: "P Atk", ru: "Физ. Атк." }), item.physicalDamage)}
      {stat(t({ en: "M Atk", ru: "Маг. Атк." }), item.magicalDamage)}
      {stat(t({ en: "Atk Spd", ru: "Скор. Атк" }), item.attackSpeed)}
      {stat(t({ en: "P Def", ru: "Защита щитом" }), item.shieldDefense)}
      {stat(t({ en: "Def Rate", ru: "Шанс блока" }), item.shieldDefenseRate)}
      {stat(t({ en: "Evasion", ru: "Уклонение" }), item.avoidModify)}
      {stat(t({ en: "P Def", ru: "Физ. Защ." }), item.physicalDefense)}
      {stat(t({ en: "M Def", ru: "Маг. Защ." }), item.magicalDefense)}
      {stat(t({ en: "MP Increase", ru: "МП Бонус" }), item.mpBonus)}
      {stat(
        t({ en: "SoulShots", ru: "Расход Зарядов Души" }),
        item.soulshotCount
      )}
      {stat(
        t({ en: "SpiritShots", ru: "Расход Зарядов Духа" }),
        item.spiritshotCount
      )}
      <div style={{ display: "flex", gap: 20 }}>
        {stat(t({ en: "Weight", ru: "Вес " }), item.weight)}
        {props.tooltip && props.item.defaultPrice !== 0 && (
          <div className={css.itemStat}>
            <span className={css.itemStatName}>
              {t({ en: "Base Price", ru: "Базовая цена" })}:
            </span>
            <span className={css.itemStatValue} style={{ color: "gold" }}>
              <AdenaValue value={props.item.defaultPrice ?? 0} />
            </span>
          </div>
        )}
      </div>

      {item.itemName.includes("_bytime") ? (
        <div style={{ margin: "10px 0", fontSize: 14 }}>
          <div style={{ color: "#fff" }}>{"<Shadow Item Info>"}</div>
          {stat(t({ en: "Total Mana", ru: "Мана" }), item.durability)}
          <div className={css.itemStat}>
            {t({
              en: "Unable to Trade/Drop",
              ru: "Нельзя обменять, выбросить",
            })}
          </div>
        </div>
      ) : null}

      {item.desc && (
        <div className={css.itemDesc}>
          {props.item.desc.replace(/\\\\n /g, "\n")}
        </div>
      )}
    </div>
  );
}

function stat(
  name: string,
  value: string | number | null | undefined | ReactNode
) {
  if (value) {
    return (
      <div className={css.itemStat}>
        <span className={css.itemStatName}>{name}:</span>
        <span className={css.itemStatValue}>{value}</span>
      </div>
    );
  }
  return null;
}
